import { render } from "./ProductDetail_EnterpriseRiskManagement.vue?vue&type=template&id=87303296&scoped=true"
import script from "./ProductDetail_EnterpriseRiskManagement.vue?vue&type=script&lang=js"
export * from "./ProductDetail_EnterpriseRiskManagement.vue?vue&type=script&lang=js"

import "./ProductDetail_EnterpriseRiskManagement.vue?vue&type=style&index=0&id=87303296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87303296"]])

export default __exports__